import React, { useState } from 'react';
import PreferitiSection from './preferiti/PreferitiSection';
import MatchSearch from '../MatchSearch';
import { classIf, getConfiguration, iconSportCssClass } from '../../../data/utils';
import GoUpBtn from '../../GoUpBtn';
import MenuSportItem from './MenuSportItem';
import { useLayout } from '../../../UISettingsProvider';
import PrematchContext from '../../../contexts/PrematchContext'

function MenuLive(props) {
    const layout = useLayout();
    const prematchContext = React.useContext(PrematchContext);

    const sportsList = props.data && props.data.sport.map(function (sport) {
        return <MenuSportItem key={sport.id} {...sport} menuLiveTogglers={props.menuLiveTogglers} />
    });

    const [collapsed, setCollapsed] = useState(false);

    function handleCollapseButton() {
        if (!collapsed) {
            document.body.classList.add('e-largo');
        } else {
            document.body.classList.remove('e-largo');
        }
        setCollapsed(!collapsed);
    }

    const menuOnRight = layout.order.sidebarSx.localeCompare('ord-3') === 0;

    return (
        <div className={"sidebar-sx-sport col stringimento-sidebar go-up-arrow-on-overflow " + layout.order.sidebarSx + classIf(collapsed, 'stringi')} id="sidebar-sx">
            <GoUpBtn />
            <div className="widget-filtro-side bordato-widget bordo-tondo margine-giu">
                <div className="filtro-side-n">
                    {/* Se il menu e' sulla destra mostro la freccia come primo elemento e ruoto l'immagine */}
                    {menuOnRight &&
                        <div className="pointer f-sidebarSX tasto-stringi ruota-180" onClick={handleCollapseButton}><i className="fas fa-chevron-left"></i></div>
                    }
                    <a className="elemento-filtro-side-n pointer" href="#/prematch">Prematch</a>
                    <a className="elemento-filtro-side-n pointer f-attivo" href="#/live">Live</a>
                    {!menuOnRight &&
                        <div className="pointer f-sidebarSX tasto-stringi" onClick={handleCollapseButton}><i className="fas fa-chevron-left"></i></div>
                    }
                </div>
                <div className="elementi-widget-fasce">
                    <div className="widget-ricerca-side">
                        <MatchSearch isLive={props.isLive} />
                    </div>
                </div>
            </div>
            <div className="widget-competizioni-side">
                <div id="accordionLaterale" className="contenitore-competizioni-sport" role="tablist" aria-multiselectable="true">
                    <PreferitiSection isLive={props.isLive} />
                </div>
                <div id="accordionLaterale" className="contenitore-competizioni-sport" role="tablist" aria-multiselectable="true">
                    {sportsList}
                </div>
            </div>
            <div className="sidebar-ristretta-sx">
                <div className={"pointer f-sidebarSX tasto-allarga" + classIf(menuOnRight, 'ruota-180')} onClick={handleCollapseButton}><i className="fas fa-chevron-right"></i></div>
                <div className="icone-ristrette">
                    <>
                        {props.data && props.data.sport.map(function (sport) {
                            const icoSport = iconSportCssClass(sport.id, sport.iconClass);
                            return (
                                <div key={sport.id} className="bloccheti-icone-ristrette">
                                    <div className={`icona-sport img-fluid ico-sport ${icoSport}`}></div>
                                </div>
                            )
                        })}
                    </>
                </div>
            </div>
        </div>
    );
}

export default MenuLive;